module.exports = __webpack_public_path__ + "img/5.964703b6.png";